import { useEffect, useState } from "react";

export default function useCompanyLocations(data, companyID, type) {
    const [locations, setLocations] = useState([]);
    const [selectedID, setSelectedID] = useState(null);

    const idKey = type === "shipping" ? "LocationID" : "BillingID";

    useEffect(() => {
        if (!companyID || !data?.[companyID]?.[type]) {
            setLocations([]);
            setSelectedID(null);
            return;
        }

        const arr = Object.values(data[companyID][type]);
        setLocations(arr);
        setSelectedID(arr[0]?.[idKey] ?? null);
    }, [data, companyID, type, idKey]);

    const selected = locations.find(loc => loc[idKey] === selectedID) ?? null;

  // Nova funkcija za dodajanje lokacije
  const addLocation = (newLoc) => {
    setLocations(prev => [...prev, newLoc]);
    setSelectedID(newLoc[idKey]);
  };

  return {
    locations,
    selected,
    selectedID,
    setSelectedID,
    addLocation
  };
}
